import { getTerminalMode } from 'utils/terminal';
import { IS_KIOSK_VENICE_MODE } from 'constants/app/configs';

// ATTENTION: this is a temporary solution for venice terminal
const size =
  IS_KIOSK_VENICE_MODE && getTerminalMode()
    ? {
        sm: '200px',
        lg: '500px',
        xl: '800px'
      }
    : {
        sm: '767px',
        lg: '1024px',
        xl: '1200px'
      };

export const DEVICE = {
  sm: `(max-width: ${size.sm})`,
  lg: `(max-width: ${size.lg})`,
  xl: `(max-width: ${size.xl})`
};
